import _ from 'lodash';
import { select, put } from 'redux-saga/effects';
import * as actions from '../state';

export default function* resetBoard() {
  const originalBoard = yield select((state) => state.editHistory.originalBoard);
  const originalCharts = yield select((state) => state.editHistory.originalCharts);

  // eslint-disable-next-line no-undef
  yield put(actions.setBoard(_.cloneDeep(originalBoard)));
  // eslint-disable-next-line no-undef
  yield put(actions.setCharts(_.cloneDeep(originalCharts)));

  yield put(actions.isDirty(false));
  yield put(actions.savedBoardState(false));
}
